module.exports = __webpack_public_path__ + "img/DigitalTV_R350E.0aa296e5.png";